import CommandResolver from '../utils/CommandResolver';
import CommandArgFuncUtil from '../utils/CommandArgFuncUtil';
import CommonUtil from '../utils/CommonUtil';
export default class LayerManager
{
    static executeLayerMethod(formModule,group,methodName,externalArgs=[])
	{
		let _parentWindow = window.parent.window;
		if(_parentWindow)
		{
		  let layerLevels = _parentWindow.layerLevelConfig;
		  //let formModule = this.formDataSources.formModule;
		  for(let i = layerLevels.length-1;i>-1;i--)
		  {
			let layerName = layerLevels[i].name;
			let layerConfig = _parentWindow.layerConfigs[layerName];
			if(layerConfig)
			{
			  let clsName = CommonUtil.getLayerClassName(formModule.formName,group?group.mainSource.alias:null);
			  if(layerConfig.hasOwnProperty(clsName))
			  {
					let classConfig = layerConfig[clsName];
					let _cls = classConfig.classDef;
					let cmdResult;
					let mathodInfo = {fetchOption:true,groups:"all(cr,sr,ar,fq,cq)",editors:"all",joinGroup:"yes"};
					if(typeof(_cls) == "function")
					{
						let instance = new _cls();
						let func = instance[methodName];
						if(!func || typeof(func) != "function")
							continue;
						let commandArg = CommandResolver.getSendCmd(formModule, group?group.groupAlias:null, mathodInfo);
						CommandArgFuncUtil.bindCommandArgFunc(commandArg);
						if(commandArg)commandArg.contextWindow = window;
						//cmdResult = instance.activeRecord(commandArg);
						cmdResult = func.apply(instance,[commandArg].concat(externalArgs));
					}
					else if(typeof(_cls == "Object"))
					{
						let instance = _cls;
						let func = instance[methodName];
						if(!func || typeof(func) != "function")
							continue;
						let commandArg = CommandResolver.getSendCmd(formModule, group?group.groupAlias:null, mathodInfo);
						//cmdResult = instance.activeRecord(commandArg);\
						CommandArgFuncUtil.bindCommandArgFunc(commandArg);
						if(commandArg)commandArg.contextWindow = window;
						cmdResult = func.apply(instance,[commandArg].concat(externalArgs));
					}
					if(typeof(cmdResult) == "string")
						return cmdResult;
					if(typeof(cmdResult) == "boolean")
						return cmdResult;
					if(cmdResult)
					{
						CommandResolver.resolve(cmdResult.tasks,formModule,group);
					}
					break;
			  }
			}
		  }
	
		}
	}
}


// WEBPACK FOOTER //
// ./src/manager/LayerManager.js